import React from "react";
import { usePlan } from "../../contexts/PlanContext";
import CommonToaster from "./CommonToaster";

/**
 * Global toast that fires whenever the backend returns a 403
 * with { planLimit: true } or { noPlan: true }.
 *
 * Rendered once in App.js — no per-page wiring needed.
 */
const PlanLimitToast = () => {
  const { planLimitAlert, dismissPlanLimitAlert } = usePlan();

  if (!planLimitAlert) return null;

  return (
    <CommonToaster
      show
      type="warning"
      position="top-center"
      delay={6000}
      message={planLimitAlert.message || "You have reached a plan limit. Please upgrade your plan."}
      onClose={dismissPlanLimitAlert}
    />
  );
};

export default PlanLimitToast;
